module.exports = __webpack_public_path__ + "img/img_1.96a66549.png";